import { FaIcons, Icons, RenderIcons } from "components/dropdowns/contentSegmentationDropdown/constants";
import { type MultiStateDropdownOption } from "components/dropdowns/multiStateDropdown/MultiStateDropdown";
import { ContentTypesEnum } from "enums";
import { EntityType } from "features/Library/Flows/Designer/types";

const getContentTypeByEntity = (entityType: string): ContentTypesEnum => {
  const contentTypes = Object.entries(contentTypeToEntityMap).find(([_, value]) => value === entityType);
  return contentTypes ? (contentTypes[0] as ContentTypesEnum) : ContentTypesEnum.Uploaded;
};

const contentTypeToEntityMap: { [key in ContentTypesEnum]?: EntityType } = {
  Flows: EntityType.Flow,
  Surveys: EntityType.Survey,
  Assessments: EntityType.Assessment,
  PDFs: EntityType.Pdf,
  Uploaded: EntityType.Video,
  Embedded: EntityType.EmbeddedVideo,
  Messages: EntityType.Message,
  Emails: EntityType.Email,
  Links: EntityType.Link,
  Campaigns: EntityType.Campaign,
  SCORM: EntityType.Scorm,
};

export const mapContextToEntityType = (context: string): EntityType => {
  if (Object.values(EntityType).includes(context as EntityType)) {
    return context as EntityType;
  }

  const contentType = context as ContentTypesEnum;

  return contentTypeToEntityMap[contentType] || EntityType.Video;
};

export const getAssetsMultiStateOption = (entityType: string): MultiStateDropdownOption<string> => {
  const contentType: ContentTypesEnum = getContentTypeByEntity(entityType);

  return {
    label: contentType,
    iconName: Icons[contentType],
    icon: FaIcons[contentType],
    renderIcon: RenderIcons[contentType],
  };
};

export const getAssetsMultiStateOptions = (
  linkAssetTypeEnabled: boolean = false,
  isTdAddonEnabled: boolean = false,
  scormEnabled: boolean = false,
): MultiStateDropdownOption<ContentTypesEnum>[] => {
  const contentOptions: MultiStateDropdownOption<ContentTypesEnum>[] = [
    {
      label: ContentTypesEnum.Videos,
      iconName: Icons.Videos,
      options: [
        {
          label: ContentTypesEnum.Uploaded,
          icon: FaIcons[ContentTypesEnum.Uploaded],
        },
        {
          label: ContentTypesEnum.Embedded,
          renderIcon: RenderIcons[ContentTypesEnum.Embedded],
        },
      ],
    },
    {
      label: ContentTypesEnum.Surveys,
      icon: FaIcons.Surveys,
    },
    {
      label: ContentTypesEnum.Assessments,
      icon: FaIcons.Assessments,
    },
    {
      label: ContentTypesEnum.PDFs,
      renderIcon: RenderIcons.PDFs,
    },
  ];

  if (linkAssetTypeEnabled) {
    contentOptions.push({
      label: ContentTypesEnum.Links,
      iconName: Icons.Links,
    });
  }

  if (scormEnabled) {
    contentOptions.push({
      label: ContentTypesEnum.Scorm,
      icon: FaIcons.SCORM,
    });
  }

  if (isTdAddonEnabled) {
    contentOptions.push({
      label: ContentTypesEnum.Campaigns,
      icon: FaIcons[ContentTypesEnum.Campaigns],
    });
  }

  return contentOptions;
};
